
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isRefreshApi: false,
};

const ridesSlice = createSlice({
    name: 'rides',
    initialState,
    reducers: {
        updateIsRefreshApi: (state, payload) => {
            state.isRefreshApi = payload.payload;
        },

    },
});

export const { updateIsRefreshApi } = ridesSlice.actions;

export default ridesSlice.reducer;
